/**
 * Default “Capabilities” tabs for Application Development & Modernization service pages.
 * Replace or override per service via {@link ServiceCapabilities} `tabs` prop.
 */
export const APPLICATION_MODERNIZATION_CAPABILITIES_EN = [
  {
    id: 'api-microservices',
    label: 'API & Microservices',
    paragraphs: [
      'We design and implement scalable APIs and microservices architectures that enable your systems to communicate seamlessly. By breaking down complex applications into smaller, independent components, we enhance flexibility, performance, and long-term maintainability.',
      'This approach accelerates development cycles and simplifies integration with third-party services, creating a solid foundation for modern, future-ready applications.',
    ],
  },
  {
    id: 'web-development',
    label: 'Web Development',
    paragraphs: [
      'We build high-performance web applications designed for scale, speed, and long-term evolution. From robust backend architectures to seamless frontend experiences, every layer is crafted with precision.',
      'Our approach prioritizes performance, accessibility, and maintainability, ensuring your product not only looks exceptional but performs flawlessly under real-world conditions.',
    ],
  },
  {
    id: 'mobile-development',
    label: 'Mobile Development',
    paragraphs: [
      'We create mobile applications that deliver intuitive, high-quality experiences across iOS and Android. Whether native or cross-platform, our solutions are engineered for performance, scalability, and user engagement.',
      'By combining strong technical foundations with thoughtful design, we ensure your mobile product feels fast, reliable, and truly native to the user.',
    ],
  },
  {
    id: 'cms-development',
    label: 'CMS-based Development',
    paragraphs: [
      'We develop flexible CMS-driven platforms that empower your team to manage and scale content effortlessly. From custom architectures to headless solutions, we ensure full control without compromising performance.',
      'Our implementations are built for adaptability, allowing your digital presence to evolve quickly as your business grows.',
    ],
  },
  {
    id: 'ux-ui',
    label: 'UX/UI',
    paragraphs: [
      'We design user experiences that are both intuitive and visually refined. Every interface is crafted to guide users naturally, reducing friction and enhancing engagement.',
      'By combining research, strategy, and design, we create digital experiences that are not only beautiful, but purposeful and effective.',
    ],
  },
]

export const APPLICATION_MODERNIZATION_CAPABILITIES_PT = [
  {
    id: 'api-microservices',
    label: 'API e microsserviços',
    paragraphs: [
      'Concebemos e implementamos APIs e arquiteturas de microsserviços escaláveis que permitem aos seus sistemas comunicar de forma fluida. Ao dividir aplicações complexas em componentes menores e independentes, ganhamos flexibilidade, desempenho e manutenção a longo prazo.',
      'Esta abordagem acelera ciclos de desenvolvimento e simplifica a integração com serviços de terceiros, criando uma base sólida para aplicações modernas e preparadas para o futuro.',
    ],
  },
  {
    id: 'web-development',
    label: 'Desenvolvimento web',
    paragraphs: [
      'Construímos aplicações web de elevado desempenho, pensadas para escala, velocidade e evolução contínua. Desde arquiteturas de backend robustas até experiências frontend coerentes, cada camada é trabalhada com precisão.',
      'Priorizamos desempenho, acessibilidade e manutenção, para que o seu produto não só tenha excelente aspeto como funcione de forma impecável em condições reais.',
    ],
  },
  {
    id: 'mobile-development',
    label: 'Desenvolvimento mobile',
    paragraphs: [
      'Criamos aplicações móveis com experiências intuitivas e de alta qualidade em iOS e Android. Seja nativo ou multiplataforma, as nossas soluções privilegiam desempenho, escalabilidade e envolvimento do utilizador.',
      'Ao combinar bases técnicas sólidas com design cuidado, garantimos que o seu produto móvel seja rápido, fiável e natural para quem o usa.',
    ],
  },
  {
    id: 'cms-development',
    label: 'Desenvolvimento com CMS',
    paragraphs: [
      'Desenvolvemos plataformas baseadas em CMS flexíveis, para a sua equipa gerir e escalar conteúdo com facilidade. De arquiteturas à medida a soluções headless, asseguramos controlo total sem sacrificar desempenho.',
      'As implementações são pensadas para adaptabilidade, permitindo que a sua presença digital evolua rapidamente à medida que o negócio cresce.',
    ],
  },
  {
    id: 'ux-ui',
    label: 'UX/UI',
    paragraphs: [
      'Desenhamos experiências de utilizador intuitivas e visualmente refinadas. Cada interface guia o utilizador de forma natural, reduzindo fricção e reforçando o envolvimento.',
      'Ao combinar investigação, estratégia e design, criamos experiências digitais que não são só bonitas, são intencionais e eficazes.',
    ],
  },
]
